export default function CsharpExceptions() {
  return (
    <h2>Csharp Exceptions</h2>
  );
}
